import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import type { ProviderAgendaSlot } from "../services/providerAgendaService";

export interface ProviderAgendaDay {
  /** YYYY-MM-DD */
  dayKey: string;
  label: string;
  slots: ProviderAgendaSlot[];
}

/** Agrupa os horários por dia ("Hoje", "Amanhã", "seg, 26/10"...), na ordem recebida. */
export function groupSlotsByDay(slots: ProviderAgendaSlot[]): ProviderAgendaDay[] {
  const today = dayjs().startOf("day");
  const days = new Map<string, ProviderAgendaDay>();
  for (const slot of slots) {
    const start = dayjs(slot.start);
    const dayKey = start.format("YYYY-MM-DD");
    if (!days.has(dayKey)) {
      const offset = start.startOf("day").diff(today, "day");
      const label =
        offset === 0
          ? "Hoje"
          : offset === 1
            ? "Amanhã"
            : start.locale("pt-br").format("ddd, DD/MM");
      days.set(dayKey, { dayKey, label, slots: [] });
    }
    days.get(dayKey)?.slots.push(slot);
  }
  return [...days.values()];
}
